// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { FetchChartRequestAction, fetchChartSuccess } from './actions';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import { FETCH_CHARTS_REQUEST } from './constants';
// import { dataHeaders } from '../../../stock_config/stock-ui-config';

import { SagaIterator } from 'redux-saga';

export function* chartSaga(action: FetchChartRequestAction): SagaIterator {
    try {
        const data = yield call(() => api.get(`${appUrls.stockURL}/chart/${action.payload}`));
        if (data) {
            const formattedData = data.data.map((item: any) => ({
                ...item,
                time: new Date(item.time).toISOString(),
            }));
            yield put(fetchChartSuccess(formattedData));
        }
    } catch (error) {
        // yield put(
        //     sendError({
        //         error,
        //         processingType: 'alert',
        //         extraOptions: {
        //             actionError: fetchTickersGroupFailure,
        //         },
        //     })
        // );
    }
}

export function* rootchartSaga(): Generator {
    yield takeLatest(FETCH_CHARTS_REQUEST, chartSaga);
}
